<ng-container>
    <div class="mx-5 my-4 user-details-container">
        <form [formGroup]="userDetailsForm">
            <div class="px-2">
                <div class="row mb-5 mt-6">
                  <div class="col-12 col-md-6 form-container mb-6">
                      <label class="form-label form-label-floating mb-3 required" 
                      [ngClass]="{'border-danger': userDetailsForm.get('firstName')?.invalid && userDetailsForm.get('firstName')?.touched}">First Name</label>
                      <input type="text" class="form-control form-control-lg form-control-solid" 
                        [ngClass]="{'border-danger': userDetailsForm.get('firstName')?.invalid && userDetailsForm.get('firstName')?.touched}"
                        formControlName="firstName" placeholder="" name="firstName" maxlength="128"/>
                      @if (userDetailsForm.get('firstName')?.invalid && userDetailsForm.get('firstName')?.touched) {
                        <span class="text-danger">
                            @if (userDetailsForm.get('firstName')?.errors?.['required']) {
                                First Name is required.
                            }
                            @else if (userDetailsForm.get('firstName')?.errors?.['pattern']) {
                                First Name must be alphanumeric.
                            }
                            @else if (userDetailsForm.get('firstName')?.errors?.['maxlength']) {
                                First Name must be no longer than 128 characters.
                            }
                        </span>
                    }
                  </div>
                  <div class="col-12 col-md-6 form-container">
                    <label class="form-label form-label-floating mb-3 required"
                    [ngClass]="{'border-danger': userDetailsForm.get('lastName')?.invalid && userDetailsForm.get('lastName')?.touched}">Last Name</label>
                    <input type="text" class="form-control form-control-lg form-control-solid" 
                    [ngClass]="{'border-danger': userDetailsForm.get('lastName')?.invalid && userDetailsForm.get('lastName')?.touched}"
                    formControlName="lastName" placeholder="" name="lastName" maxlength="128"/>
                    @if (userDetailsForm.get('lastName')?.invalid && userDetailsForm.get('lastName')?.touched) {
                        <span class="text-danger">
                            @if (userDetailsForm.get('lastName')?.errors?.['required']) {
                                Last Name is required.
                            }
                            @else if (userDetailsForm.get('lastName')?.errors?.['pattern']) {
                                Last Name must be alphanumeric.
                            }
                            @else if (userDetailsForm.get('lastName')?.errors?.['maxlength']) {
                                Last Name must be no longer than 128 characters.
                            }
                        </span>
                    }
                  </div>
                </div>
                <div class="row mb-5">
                    <div class="col-12 col-md-6 form-container">
                        <label class="form-label form-label-floating mb-3 required"
                        [ngClass]="{'border-danger': userDetailsForm.get('userName')?.invalid && userDetailsForm.get('userName')?.touched}">User Name</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" 
                        [ngClass]="{'border-danger': userDetailsForm.get('userName')?.invalid && userDetailsForm.get('userName')?.touched}"
                        formControlName="userName" placeholder="" name="userName" maxlength="128"/>
                        @if (userDetailsForm.get('userName')?.invalid && userDetailsForm.get('userName')?.touched) {
                            <span class="text-danger">
                                @if (userDetailsForm.get('userName')?.errors?.['required']) {
                                    User Name is required.
                                }
                                @else if (userDetailsForm.get('userName')?.errors?.['pattern']) {
                                    User Name must be alphanumeric.
                                }
                                @else if (userDetailsForm.get('userName')?.errors?.['maxlength']) {
                                    User Name must be no longer than 128 characters.
                                }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <input type="checkbox" class="form-check-input me-2" formControlName="isActive" name="isActive" [value]="1"
                            [checked]="userDetailsForm.get('isActive')?.value === 1" 
                            (change)="onCheckboxChange($event)"/> 
                        <label class="form-check-label mt-1 ms-1 text-black">Active</label>
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required"
                        [ngClass]="{'border-danger': userDetailsForm.get('companyId')?.invalid && userDetailsForm.get('companyId')?.touched}">Company</label>
                        <select class="form-control form-control-lg form-control-solid" (change)="onCompanyChange($event)" 
                        [ngClass]="{'border-danger': userDetailsForm.get('companyId')?.invalid && userDetailsForm.get('companyId')?.touched}"
                            formControlName="companyId" name="companyId">
                            <option [value]="null">Select Company</option>
                            <option [value]="company.companyId" *ngFor="let company of this.companyList()">
                                {{company.companyName}}
                            </option>
                        </select>
                        @if (userDetailsForm.get('companyId')?.invalid && userDetailsForm.get('companyId')?.touched) {
                            <span class="text-danger">
                                @if (userDetailsForm.get('companyId')?.errors?.['required']) {
                                    Company is required.
                                }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required"
                        [ngClass]="{'border-danger': userDetailsForm.get('branchId')?.invalid && userDetailsForm.get('branchId')?.touched}">Branch</label>
                        <select class="form-control form-control-lg form-control-solid" 
                        [ngClass]="{'border-danger': userDetailsForm.get('branchId')?.invalid && userDetailsForm.get('branchId')?.touched}"
                            formControlName="branchId" name="branchId">
                            <option [value]="null">Select Branch</option>
                            <option [value]="branch.branchId" *ngFor="let branch of this.branchList()">
                                {{branch.branchName}}
                            </option>
                        </select>
                        @if (userDetailsForm.get('branchId')?.invalid && userDetailsForm.get('branchId')?.touched) {
                            <span class="text-danger">
                                @if (userDetailsForm.get('branchId')?.errors?.['required']) {
                                    Branch is required.
                                }
                            </span>
                        }
                    </div>
                </div>
                <div class="row mb-5"> 
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required"
                        [ngClass]="{'border-danger': userDetailsForm.get('userRoleId')?.invalid && userDetailsForm.get('userRoleId')?.touched}">User Role</label>
                        <select class="form-control form-control-lg form-control-solid" 
                        [ngClass]="{'border-danger': userDetailsForm.get('userRoleId')?.invalid && userDetailsForm.get('userRoleId')?.touched}"
                            formControlName="userRoleId" name="userRoleId">
                            <option [value]="null">Select User Role</option>
                            <option [value]="user.roleId" *ngFor="let user of this.userRoleList()">
                                {{user.roleName}}
                            </option>
                        </select>
                        @if (userDetailsForm.get('userRoleId')?.invalid && userDetailsForm.get('userRoleId')?.touched) {
                            <span class="text-danger">
                                @if (userDetailsForm.get('userRoleId')?.errors?.['required']) {
                                    User Role is required.
                                }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6 phone-input-container">
                        <label class="form-label form-label-floating mb-3 required"
                        [ngClass]="{'border-danger': userDetailsForm.get('mobileNumber')?.invalid && userDetailsForm.get('mobileNumber')?.touched}">Mobile Number</label>
                        <ngx-intl-tel-input
                            [preferredCountries]="[CountryISO.UnitedStates, CountryISO.UnitedKingdom]"
                            [enableAutoCountrySelect]="false"
                            [enablePlaceholder]="false"
                            [searchCountryFlag]="true"
                            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                            [searchCountryPlaceholder]="'Search...'"
                            [selectFirstCountry]="false"
                            [selectedCountryISO]="userDetailsForm.get('mobileNumberCountryCode')?.value || CountryISO.UnitedStates"
                            [phoneValidation]="false"
                            [separateDialCode]="true"
                            [maxLength]="getMaxPhoneLength(userDetailsForm.get('mobileNumberCountryCode')?.value)"
                            formControlName="mobileNumber"
                            name="mobileNumber"
                            (countryChange)="onMobileNumberCountryChange($event)"
                            (blur)="onMobileNumberBlur()">
                        </ngx-intl-tel-input>
                        @if (userDetailsForm.get('mobileNumber')?.invalid && userDetailsForm.get('mobileNumber')?.touched) {
                            <span class="text-danger">
                                @if (userDetailsForm.get('mobileNumber')?.errors?.['required']) {
                                    Mobile number is required.
                                }
                            </span>
                        }
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col-12 col-md-3 form-container mb-6 phone-input-container">
                        <label class="form-label form-label-floating mb-3 required"
                        [ngClass]="{'border-danger': userDetailsForm.get('phone')?.invalid && userDetailsForm.get('phone')?.touched}">Phone Number</label>
                        <ngx-intl-tel-input
                            [preferredCountries]="[CountryISO.UnitedStates, CountryISO.UnitedKingdom]"
                            [enableAutoCountrySelect]="false"
                            [enablePlaceholder]="false"
                            [searchCountryFlag]="true"
                            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                            [searchCountryPlaceholder]="'Search...'"
                            [selectFirstCountry]="false"
                            [selectedCountryISO]="userDetailsForm.get('phoneCountryCode')?.value || CountryISO.UnitedStates"
                            [phoneValidation]="false"
                            [separateDialCode]="true"
                            [maxLength]="getMaxPhoneLength(userDetailsForm.get('phoneCountryCode')?.value)"
                            formControlName="phone"
                            name="phone"
                            (countryChange)="onPhoneCountryChange($event)"
                            (blur)="onPhoneBlur()">
                        </ngx-intl-tel-input>
                        @if (userDetailsForm.get('phone')?.invalid && userDetailsForm.get('phone')?.touched) {
                            <span class="text-danger">
                                @if (userDetailsForm.get('phone')?.errors?.['required']) {
                                    Phone number is required.
                                }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-3 form-container mb-6">
                        <label class="form-label form-label-floating mb-3"
                        [ngClass]="{'border-danger': userDetailsForm.get('iPhoneExt')?.invalid && userDetailsForm.get('iPhoneExt')?.touched}">Phone Number Extension</label>
                        <input type="text" class="form-control form-control-lg form-control-solid" 
                        [ngClass]="{'border-danger': userDetailsForm.get('iPhoneExt')?.invalid && userDetailsForm.get('iPhoneExt')?.touched}"
                        formControlName="iPhoneExt" placeholder="" name="iPhoneExt"/>
                        @if (userDetailsForm.get('iPhoneExt')?.invalid && userDetailsForm.get('iPhoneExt')?.touched) {
                            <span class="text-danger">
                                @if (userDetailsForm.get('iPhoneExt')?.errors?.['maxlength']) {
                                Phone Number Extension must be no longer than 6 characters.
                            }
                            </span>
                        }
                    </div>
                    <div class="col-12 col-md-6 form-container mb-6">
                        <label class="form-label form-label-floating mb-3 required"
                        [ngClass]="{'border-danger': userDetailsForm.get('userEmail')?.invalid && userDetailsForm.get('userEmail')?.touched}">Email Address</label>
                        <input type="email" class="form-control form-control-lg form-control-solid" 
                        [ngClass]="{'border-danger': userDetailsForm.get('userEmail')?.invalid && userDetailsForm.get('userEmail')?.touched}"
                        formControlName="userEmail" placeholder="" name="userEmail" autocomplete="off"/>
                        @if (userDetailsForm.get('userEmail')?.invalid && userDetailsForm.get('userEmail')?.touched) {
                            <span class="text-danger">
                                @if (userDetailsForm.get('userEmail')?.errors?.['required']) {
                                    Email is required.
                                }@else if (userDetailsForm.get('userEmail')?.errors?.['pattern']) {
                                    Please enter a valid email address.
                                }
                            </span>
                        }
                    </div>
                </div>                                                 
          </div>
        </form>
    </div>
    <mat-action-row class="accordion-footer d-flex justify-content-end py-5 px-6">
        <button mat-button type="button" (click)="onCancel()"  class="btn btn-lg btn-light-primary me-3 back-btn">Cancel</button>
        <div [attr.title]="this.userDetailsForm.invalid ? 'Please fix the errors in the form.' : null">
            <button mat-button type="submit" (click)="onSubmit()"  [disabled]="this.userDetailsForm.invalid" class="btn btn-lg btn-primary continue-btn">{{ isCreateUser ? 'Create' : 'Save' }}</button>                                                      
        </div>
    </mat-action-row> 
</ng-container>